import PageHeader from '../reusable/PageHeader';
import { USER_ROLES, NAVIGATION_LINKS_DATA } from '../../constants';
import useUserDetails from '../hooks/useUserDetails';
import Loader from '../reusable/Loader';
import ProgressStatusView from './DashboardContent';

function Dashboard() {
  const {
    userDetails: { isPending, error, data: userDetails },
  } = useUserDetails();

  if (isPending) return <Loader />;
  if (error || !userDetails) return <p className="center-text">Missing user details data!</p>;

  return (
    <>
      <PageHeader title={NAVIGATION_LINKS_DATA.DASHBOARD.label} pageDescription="Review your progress on EOAA tasks" />
      <div className="main-content dashboard-main-content">
        {(userDetails.role === USER_ROLES.LEAD_FACILITATOR ||
          userDetails.role === USER_ROLES.FACILITATOR ||
          userDetails.role === USER_ROLES.XQ_ADMIN) && <ProgressStatusView userDetails={userDetails} />}
      </div>
    </>
  );
}

export default Dashboard;
